/**
 * @generated SignedSource<<0b9fdf5552be7837efb422387401f0b3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameBankAccountInput = {
  id: string;
  name: string;
};
export type EditBankAccountDialogRenameMutation$variables = {
  input: RenameBankAccountInput;
};
export type EditBankAccountDialogRenameMutation$data = {
  readonly renameBankAccount: {
    readonly id: string;
    readonly name: string;
  };
};
export type EditBankAccountDialogRenameMutation = {
  response: EditBankAccountDialogRenameMutation$data;
  variables: EditBankAccountDialogRenameMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "renameBankAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditBankAccountDialogRenameMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditBankAccountDialogRenameMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b9da8cb6ce73d7ec2fadf88eb851d873",
    "id": null,
    "metadata": {},
    "name": "EditBankAccountDialogRenameMutation",
    "operationKind": "mutation",
    "text": "mutation EditBankAccountDialogRenameMutation(\n  $input: RenameBankAccountInput!\n) {\n  renameBankAccount(input: $input) {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d18810a38bbd70c9b9eb879e7abed7d";

export default node;
